import api from './axios';

export const getBadgeTypes = (params) => api.get('/student-badge-types', { params });
export const createBadgeType = (data) => api.post('/student-badge-types', data);
export const updateBadgeType = (id, data) => api.put(`/student-badge-types/${id}`, data);
export const deleteBadgeType = (id) => api.delete(`/student-badge-types/${id}`);

export const getStudentBadges = (studentId) => api.get(`/students/${studentId}/badges`);
export const assignStudentBadge = (studentId, data) => api.post(`/students/${studentId}/badges`, data);
export const removeStudentBadge = (studentId, badgeId) => api.delete(`/students/${studentId}/badges/${badgeId}`);
